import { render, staticRenderFns } from "./bannerTable.vue?vue&type=template&id=38ad5dbe&scoped=true"
import script from "./bannerTable.vue?vue&type=script&lang=js"
export * from "./bannerTable.vue?vue&type=script&lang=js"
import style0 from "./bannerTable.vue?vue&type=style&index=0&id=38ad5dbe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad5dbe",
  null
  
)

export default component.exports